"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7840],{

/***/ 9592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23043);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])(), settings = ref.publicRuntimeConfig.settings;
var SelectSearch = function(props) {
    var hasError = props.meta && props.meta.touched && props.meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.id,
                className: "\n            Form-label\n            ".concat(props.labelClass && props.labelClass, "\n            ").concat(props.required ? "is-required" : "", "\n            ").concat(props.disabled ? "disabled" : "", "\n          "),
                children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: props.label
                    },
                    className: "inline-block"
                }) : props.label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "select-with-search w-full relative ".concat(props.containerClassName),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpread({
                        components: {
                            IndicatorSeparator: function() {
                                return null;
                            },
                            Control: Control,
                            Option: Option,
                            Menu: Menu,
                            IndicatorsContainer: IndicatorsContainer
                        },
                        instanceId: props.id,
                        isDisabled: props.disabled,
                        isClearable: false,
                        hasError: hasError,
                        controlClassName: props.controlClassName,
                        menuPlacement: props.menuPlacement || "top",
                        maxMenuHeight: props.maxMenuHeight || 260,
                        menuShouldScrollIntoView: true,
                        menuClassName: props.menuClassName,
                        placeholder: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-black text-base font-normal leading-18.2",
                            children: props.placeholder
                        }),
                        options: props.options,
                        styles: {
                            valueContainer: function(rest) {
                                return _objectSpread({}, rest, props.valueContainerStyle);
                            }
                        }
                    }, props.input)),
                    props.loadingData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "ui dimmer inverted active",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ui loader"
                        })
                    })
                ]
            }),
            hasError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-red-brand text-sm mt-2px",
                children: props.meta.error
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n        .select-with-search .has-check:after {\n          content: url(".concat(settings.websiteStatics, "/images/check.svg);\n          display: inline-block;\n          float: right;\n        }\n      ")
            })
        ]
    }));
};
var colors = {
    selected: settings.websiteName === "altex" || settings.websiteName === "bricostore" ? "text-red-brand has-check" : "bg-secondary text-white"
};
var Menu = function(_param) {
    var children = _param.children, innerRef = _param.innerRef, innerProps = _param.innerProps, getStyles = _param.getStyles, selectProps = _param.selectProps, rest = _objectWithoutProperties(_param, [
        "children",
        "innerRef",
        "innerProps",
        "getStyles",
        "selectProps"
    ]);
    var menuClassName = selectProps.menuClassName;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        style: _objectSpread({}, getStyles("menu", rest), {
            marginTop: "-1px",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }),
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({}, menuClassName, menuClassName)),
        children: children
    })));
};
var Control = function(param) {
    var children = param.children, innerRef = param.innerRef, innerProps = param.innerProps, isDisabled = param.isDisabled, isFocused = param.isFocused, selectProps = param.selectProps;
    var controlClassName = selectProps.controlClassName;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({
            "flex rounded-bl-lg rounded-tr-lg justify-between border shadow-inner overflow-hidden": true,
            "border-gray-1100": !selectProps.hasError,
            "border-red-brand bg-red-bg": selectProps.hasError,
            "opacity-50": isDisabled,
            "rounded-b-none": selectProps.hasError || isFocused
        }, controlClassName, controlClassName)),
        style: {
            height: "44px",
            maxWidth: "390px",
            minWidth: "260px",
            background: "white"
        },
        children: children
    })));
};
var Option = function(_param) /*#__PURE__*/ {
    var children = _param.children, innerRef = _param.innerRef, innerProps = _param.innerProps, getStyles = _param.getStyles, isSelected = _param.isSelected, isFocused = _param.isFocused, rest = _objectWithoutProperties(_param, [
        "children",
        "innerRef",
        "innerProps",
        "getStyles",
        "isSelected",
        "isFocused"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({
            "active:bg-newGray hover:bg-newGray": !isSelected,
            "bg-newGray": isFocused
        }, colors.selected, isSelected)),
        style: _objectSpread({}, getStyles("option", rest), {
            backgroundColor: null,
            color: null
        }),
        children: children
    }));
};
var IndicatorsContainer = function(_param) {
    var children = _param.children, innerRef = _param.innerRef, innerProps = _param.innerProps, getStyles = _param.getStyles, selectProps = _param.selectProps, rest = _objectWithoutProperties(_param, [
        "children",
        "innerRef",
        "innerProps",
        "getStyles",
        "selectProps"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            "rotate-180": selectProps.menuIsOpen
        }),
        style: _objectSpread({}, getStyles("indicatorsContainer", rest)),
        children: children
    })));
};
SelectSearch.defaultProps = {
    id: null,
    label: "",
    required: false,
    disabled: false,
    placeholder: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectSearch);


/***/ }),

/***/ 4969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52077);
/* harmony import */ var _components_Stores_StoreSchedule__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97988);





var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), settings = ref.publicRuntimeConfig.settings;
var StoreCard = function(param) {
    var store = param.store;
    var name = store.name, address = store.address, distance = store.distance, schedule = store.schedule, special_schedule = store.special_schedule;
    var link = "".concat(settings.baseUrl, "/magazine/").concat(store.url_key, "/");
    // const image = store.image && `${settings.cdn}/media/location/image${store.image}`;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "flex flex-col lg:block border py-4 px-3 lg:px-0 md:border-0 rounded-tr-lg rounded-bl-lg text-sm h-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: "mb-2 font-medium text-xl lg:text-lg leading-26 lg:leading-23.4 -tracking-0.39",
                children: name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "lg:mb-3 -tracking-0.29",
                children: [
                    address,
                    distance && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("em", {
                                children: [
                                    "Distanta",
                                    " ",
                                    distance < 10 ? distance.toFixed(2) : distance.toFixed(0),
                                    "km"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "m-0 mb-3 -tracking-0.29",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Stores_StoreSchedule__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    schedule: schedule,
                    special_schedule: special_schedule
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-auto button-is-block-on-mobile",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    title: "Vezi detalii",
                    display: "inline",
                    displayMobile: "block",
                    variant: "primary",
                    size: "normal",
                    href: link,
                    font: "semibold",
                    tracking: "-tracking-0.22"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n        @media (max-width: 768px) {\n          .button-is-block-on-mobile a {\n            display: block;\n          }\n        }\n      "
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StoreCard);


/***/ }),

/***/ 53847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var _components_Alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16479);
/* harmony import */ var _components_Stores_StoreCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4969);






var StoresMapNoSSR = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9269), __webpack_require__.e(3261)]).then(__webpack_require__.bind(__webpack_require__, 33261));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33261)
            ];
        }
    },
    ssr: false
});
var StoreCards = function(param) {
    var stores = param.stores;
    // Display store cards if we have stores
    if (stores && stores.length > 0) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mb-12",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "lg:mb-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoresMapNoSSR, {
                        markers: stores
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "flex flex-wrap m-0 lg:-ml-20 -ml-6 p-0 leading-20",
                    children: stores.map(function(store) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "w-full sm:w-1/2 md:w-1/3 pl-6 lg:pl-20 mt-6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Stores_StoreCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                store: store
                            })
                        }, store.id);
                    })
                })
            ]
        }));
    }
    // Fallback, no stores
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mb-6",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alert__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            type: "info",
            showIcon: true,
            children: "Nu au fost gasite magazine"
        })
    }));
};
StoreCards.propTypes = {
    stores: prop_types__WEBPACK_IMPORTED_MODULE_5___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
        id: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number.isRequired),
        name: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
        address: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
        distance: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
        image: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
        url_key: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired)
    }).isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (StoreCards);


/***/ }),

/***/ 97988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Stores_StoreSchedule; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/every.js
var every = __webpack_require__(711);
var every_default = /*#__PURE__*/__webpack_require__.n(every);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 41 modules
var parse = __webpack_require__(35337);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/compareAsc/index.js
var compareAsc = __webpack_require__(49474);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/closestIndexTo/index.js
var closestIndexTo = __webpack_require__(85573);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/ro/index.js + 5 modules
var ro = __webpack_require__(88397);
;// CONCATENATED MODULE: ./components/Stores/StoreSpecialSchedule.js








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var StoreSpecialSchedule = function(param1) {
    var schedule1 = param1.schedule;
    // TODO: We should use setDefaultOptions to set global defaults for date-fns
    var currentDate = new Date();
    var scheduleDateFormat = "d MMMM";
    var scheduleDateParseOptions = {
        locale: ro/* default */.Z
    };
    var parsedSchedule = Object.entries(schedule1).map(function(param) {
        var _param = _slicedToArray(param, 2), date = _param[0], openHours = _param[1];
        var dateObject;
        var isValidDate = false;
        try {
            // The schedule date doesn't contain the year
            // Use the current year to set year context
            var currentYearScheduleDate = (0,parse["default"])(date, scheduleDateFormat, currentDate, scheduleDateParseOptions);
            isValidDate = (0,isValid["default"])(currentYearScheduleDate);
            if (isValidDate) {
                // Guess the schedule date year
                var nextYearScheduleDate = (0,add/* default */.Z)(currentYearScheduleDate, {
                    years: 1
                });
                dateObject = (0,closestIndexTo/* default */.Z)(currentDate, [
                    currentYearScheduleDate,
                    nextYearScheduleDate, 
                ]) === 0 ? currentYearScheduleDate : nextYearScheduleDate;
            }
        } catch (error) {
            ;
        }
        return {
            date: date,
            openHours: openHours,
            dateObject: dateObject,
            isValidDate: isValidDate
        };
    });
    var isValidSchedule = every_default()(parsedSchedule, function(schedule) {
        return schedule.isValidDate;
    });
    var sortedSchedule = isValidSchedule && parsedSchedule.sort(function(scheduleA, scheduleB) {
        return (0,compareAsc/* default */.Z)(scheduleA.dateObject, scheduleB.dateObject);
    });
    if (!isValidSchedule) return null;
    return sortedSchedule.map(function(param, index) {
        var date = param.date, openHours = param.openHours;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "font-medium mr-1",
                    children: [
                        date,
                        ":"
                    ]
                }),
                " ",
                openHours
            ]
        }, index);
    });
};
/* harmony default export */ var Stores_StoreSpecialSchedule = (StoreSpecialSchedule);

// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
;// CONCATENATED MODULE: ./components/Stores/StoreSchedule.js



var StoreSchedule = function(param) {
    var schedule = param.schedule, special_schedule = param.special_schedule;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "mt-3",
        children: [
            special_schedule && Object.keys(special_schedule).length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 text-red-brand",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stores_StoreSpecialSchedule, {
                    schedule: special_schedule
                })
            }),
            schedule && schedule.length !== 0 && (0,helpers/* getStoreCombinedSchedule */.ne)(schedule).map(function(day, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-medium mr-1",
                            children: day.endDay ? "".concat(day.startDay, " — ").concat(day.endDay, ": ") : "".concat(day.startDay, ": ")
                        }),
                        day.openHours
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var Stores_StoreSchedule = (StoreSchedule);


/***/ }),

/***/ 37497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Stores_StoresLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/Stores/RegionsBox.js





var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, settings = _publicRuntimeConfig.settings, websiteTitle = _publicRuntimeConfig.content.websiteTitle;
var RegionsBox = function(param) {
    var regions = param.regions;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "border border-transparent rounded-tr-xl rounded-bl-xl stores-image p-6 lg:px-16 lg:pt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "flex flex-wrap text-left font-normal leading-4 m-0 p-0 -ml-3",
            children: regions.map(function(region) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "w-1/2 sm:w-1/4 md:w-1/5 pl-3 lg:leading-23.4 leading-28.6 -tracking-0.33",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "".concat(settings.baseUrl, "/magazine/").concat(region.url_key, "/"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: "Magazinele ".concat(websiteTitle, " din ").concat(region.name),
                            children: region.name
                        })
                    })
                }, region.id));
            })
        })
    });
};
RegionsBox.propTypes = {
    regions: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired
    }).isRequired)
};
/* harmony default export */ var Stores_RegionsBox = (RegionsBox);

;// CONCATENATED MODULE: ./components/Stores/StoresLayout.js






var StoresLayout_ref = (0,config["default"])(), StoresLayout_publicRuntimeConfig = StoresLayout_ref.publicRuntimeConfig, StoresLayout_websiteTitle = StoresLayout_publicRuntimeConfig.content.websiteTitle, websiteStatics = StoresLayout_publicRuntimeConfig.settings.websiteStatics;
var StoresLayout = function(param) {
    var children = param.children, title = param.title, regions = param.regions;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "lg:pt-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                title: title,
                as: "h1",
                display: "h1",
                classesProp: "text-left mb-2 mt-4 lg:mt-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-3 pr-8 text-justify text-sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-0 leading-22 lg:leading-20 -tracking-0.39",
                            children: "Prin reteaua nationala de magazine, ".concat(StoresLayout_websiteTitle, " iti ofera o gama variata de produse, la cele mai avantajoase preturi, sustinute de solutii optime de finantare, adaptate fiecarui tip de buget.")
                        })
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                title: "Vezi magazinele ".concat(StoresLayout_websiteTitle, " din regiune"),
                as: "h1",
                display: "h1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stores_RegionsBox, {
                    regions: regions
                })
            })
        ]
    }));
};
StoresLayout.prototype = {
    children: (prop_types_default()).node.isRequired,
    title: (prop_types_default()).string.isRequired,
    regions: (prop_types_default()).object.isRequired
};
/* harmony default export */ var Stores_StoresLayout = (StoresLayout);


/***/ }),

/***/ 58593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Stores_StoresRegionSelect; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Form/SelectSearch.js
var SelectSearch = __webpack_require__(9592);
;// CONCATENATED MODULE: ./components/Stores/RegionSelect.js




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var RegionSelect = function(param1) {
    var regions = param1.regions, currentRegion = param1.currentRegion, defaultLabel = param1.defaultLabel, handleRegionChange = param1.handleRegionChange, maxMenuHeight = param1.maxMenuHeight, menuPlacement = param1.menuPlacement;
    var options = regions.map(function(param) {
        var url_key = param.url_key, name = param.name;
        return {
            value: url_key,
            label: name
        };
    });
    var defaultValue = {
        value: "",
        label: defaultLabel || "Selecteaza o regiune"
    };
    var selected = currentRegion && regions.find(function(region) {
        return region.url_key === currentRegion;
    });
    var value1 = selected ? {
        value: selected.url_key,
        label: selected.name
    } : defaultValue;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative z-10 min-w-[190px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectSearch/* default */.Z, {
            input: {
                value: value1,
                onChange: function(param) {
                    var value = param.value;
                    return handleRegionChange(value);
                }
            },
            options: [
                defaultValue
            ].concat(_toConsumableArray(options)),
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement
        })
    }));
};
RegionSelect.propTypes = {
    regions: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: (prop_types_default()).string.isRequired
    }).isRequired).isRequired,
    currentRegion: (prop_types_default()).string,
    handleRegionChange: (prop_types_default()).func.isRequired
};
/* harmony default export */ var Stores_RegionSelect = (RegionSelect);

;// CONCATENATED MODULE: ./components/Stores/StoresRegionSelect.js






var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteTitle = _publicRuntimeConfig.content.websiteTitle;
var onUserRegionChange = function(regionUrlKey) {
    if (!regionUrlKey) {
        // If user selected the default regionUrlKey
        // Redirect to stores page
        router["default"].push("/magazine");
    } else {
        // User didn't select the default regionUrlKey
        // Redirect to selected region
        router["default"].push("/magazine/".concat(regionUrlKey));
    }
};
var StoresRegionSelect = function(param) {
    var regions = param.regions, currentRegion = param.currentRegion;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col md:flex-row items-center text-left my-4 -tracking-0.33",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "w-full md:w-auto text-base font-medium text-justify md:mr-3 h-full flex items-center leading-20.8",
                htmlFor: "location",
                children: "Magazinele ".concat(websiteTitle, " din")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full md:w-1/5 pt-4 md:pt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stores_RegionSelect, {
                    handleRegionChange: onUserRegionChange,
                    currentRegion: currentRegion,
                    regions: regions,
                    defaultLabel: "Toate regiunile",
                    menuPlacement: "bottom"
                })
            })
        ]
    });
};
StoresRegionSelect.propTypes = {
    regions: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired
    }).isRequired).isRequired,
    currentRegion: (prop_types_default()).string
};
/* harmony default export */ var Stores_StoresRegionSelect = (StoresRegionSelect);


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var withRouterPageLayout = function(ComposedComponent) {
    var WithRouteWrapper = /*#__PURE__*/ function(Component1) {
        "use strict";
        _inherits(WithRouteWrapper, Component1);
        var _super = _createSuper(WithRouteWrapper);
        function WithRouteWrapper() {
            _classCallCheck(this, WithRouteWrapper);
            return _super.apply(this, arguments);
        }
        _createClass(WithRouteWrapper, [
            {
                key: "render",
                value: function render() {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComposedComponent, _objectSpread({
                        router: this.context.router
                    }, this.props)));
                }
            }
        ]);
        return WithRouteWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.Component);
    _defineProperty(WithRouteWrapper, "contextTypes", {
        router: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
    });
    WithRouteWrapper.getInitialProps = ComposedComponent.getInitialProps;
    // Hoists non standard static properties
    WithRouteWrapper.pageLayout = ComposedComponent.pageLayout;
    WithRouteWrapper.layoutProps = ComposedComponent.layoutProps;
    WithRouteWrapper.pageName = ComposedComponent.pageName;
    return WithRouteWrapper;
};
/* harmony default export */ __webpack_exports__["Z"] = (withRouterPageLayout);


/***/ }),

/***/ 76208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r8": function() { return /* binding */ getStores; },
/* harmony export */   "y3": function() { return /* binding */ getStoreByUrlPath; },
/* harmony export */   "MM": function() { return /* binding */ getLockersList; }
/* harmony export */ });
/* unused harmony export getUserLocation */
/* harmony import */ var _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69170);
/* harmony import */ var _lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45963);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2642);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);




var getStores = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES */ .lc,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES_SUCCESS */ .B6,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES_FAILURE */ .Md
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            // spinnerMessage: "Loading stores list",
            alert: false,
            // alertMessage: `Get stores couldn't be completed...`,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getStoresApi */ .n5p,
            apiArgs: [],
            formatResponse: function(response) {
                return response.data.stores;
            }
        });
    };
};
var getStoreByUrlPath = function(urlPath) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH */ .fw,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH_SUCCESS */ .F0,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH_FAILURE */ .o8
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se incarca lista magazinelor",
            alert: false,
            // alertMessage: `Get stores couldn't be completed...`,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getStoreByUrlPathApi */ .XM9,
            apiArgs: [
                encodeURIComponent(urlPath)
            ],
            formatResponse: function(response) {
                return {
                    store: response.data.stores[0]
                };
            }
        });
    };
};
var getUserLocation = function() {
    return function(dispatch) {
        // Dispatch get user location action
        dispatch({
            type: GET_USER_LOCATION
        });
        // Check if browser has geolocation support and is enabled
        getBrowserGeolocation().then(function(result) {
            dispatch({
                type: GET_USER_LOCATION_SUCCESS,
                payload: result
            });
        }).catch(function(error) {
            // Catch error and dispatch get user location failure
            dispatch({
                type: GET_USER_LOCATION_FAILURE,
                error: error.message
            });
        });
    };
};
var getLockersList = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST */ .nv,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST_SUCCESS */ .DP,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST_FAILURE */ .IM
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: false,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getLockersApi */ .p5Y,
            apiArgs: [],
            formatResponse: function(response) {
                return response.data.data.lockers;
            }
        });
    };
};


/***/ })

}]);